import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { _AppliedIncapacity } from "../../../../../core/services/dataBean/EntityCatalogVdos";


interface Props {
    idIncapacity: number;
}

export const AppliedIncapacity = ({ idIncapacity }: Props) => {

    const applied = useDataBean(_AppliedIncapacity);

    const [lista, setLista] = useState<any>([]);
    useEffect(() => {
        getLista();
    }, [idIncapacity])

    const getLista = () => {

        applied.instance.getMonthAppliedIncapacityCatalog(idIncapacity).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        ).catch(err => { toast.error(err) })

    }

    const head = [
        { title: 'ID', property: 'IDMonthAppliedIncapacity', visible: true },
        { title: 'Días Liquidados', property: 'AppliedDays', visible: true },
        { title: 'Fecha inicio reportada PILA', property: 'FromDate', visible: true },
        { title: 'Fecha final reportada PILA', property: 'UptoDate', visible: true },
        { title: 'Vigencia Aplicación', property: 'Year', visible: true },
        { title: 'Mes Aplicación', property: 'MonthName', visible: true },
        { title: '+90 Días', property: 'Days_90', visible: true },
        { title: '+180 Días', property: 'Days_180', visible: true },
        { title: 'IBC Aplicado', property: 'AppliedIBC', visible: true },
    ]

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={applied.setBean} ></BasicTable>
            </div>
        </div>
    )
}